export default __webpack_public_path__ + "images/OV.6263a59.png";